export const parseRawBoolean = (value) => value === '1' || value === 'Y' || value === 1;
const convertToDateString = (year, month, day) => `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
/**
 * Helper function to parse the key of the API response for /booking/addons endpoint which has the following format:
 *
 * roomId-packageId-checkinYear-checkinMonth-checkinDay-checkoutYear-checkoutMonth-checkoutDay-adults-kids
 *
 */
export const parseRawAddonListKey = (key) => {
    const [roomId, packageId, checkinYear, checkinMonth, checkinDay, checkoutYear, checkoutMonth, checkoutDay, adults, kids,] = key.split('-');
    return {
        adults: parseInt(adults),
        checkin: convertToDateString(checkinYear, checkinMonth, checkinDay),
        checkout: convertToDateString(checkoutYear, checkoutMonth, checkoutDay),
        kids: parseInt(kids),
        packageId: parseInt(packageId),
        roomId,
    };
};
export const getRawAccommodationLinkedId = ({ package_id, rate_id, room_type_id, }) => `${room_type_id}-${package_id}-${rate_id}`;
